import { ClinicProduct } from './clinic-product';

export class ProductBrand {
  id: number;
  name: string;
  clinicProducts: ClinicProduct[];
}
